import "./styles/index.css";
import React from "react";
import ReactDOM from "react-dom";
import Esign from "./components/Esign";
import PageNotFound from "./components/PageNotFound";
import Access from "./components/Access";
import Login from "./components/Login";
import Browse from "./components/Browse";
import ViewDocument from "./components/Viewer";
import Completed from "./components/Completed";
import ErrorCode from "./components/ErrorCode";
import Declined from "./components/Declined";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <Routes>
        <Route path="/" element={<Access />} />
        <Route path="/access" element={<Access />} />
        <Route path="/access/:logo" element={<Access />} />

        <Route path="/login" element={<Login />} />
        <Route path="/login/:logo" element={<Login />} />

        <Route path="/browse" element={<Browse />} />
        <Route path="/browse/:logo" element={<Browse />} />

        <Route path="/viewer/:id" element={<ViewDocument />} />

        <Route path="/completed" element={<Completed />} />
        <Route path="/completed/:logo" element={<Completed />} />

        <Route path="/document/:id" element={<Esign />} />

        <Route path="/declined" element={<Declined />} />
        <Route path="/declined/:logo" element={<Declined />} />

        <Route path="/404" element={<PageNotFound />} />
        <Route path="/404/:logo" element={<PageNotFound />} />

        <Route path="/error" element={<ErrorCode />} />
        <Route path="/error/:logo" element={<ErrorCode />} />

        <Route path="/*" element={<PageNotFound />} />
      </Routes>
    </Router>
  </React.StrictMode>,
  document.getElementById("root")
);
